import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  /** `onDark` = footer scuri con testo bianco a opacità ridotta (footer marketing). */
  tone?: "default" | "onDark";
};

export function BeLeadSignature({ className, tone = "default" }: Props) {
  const muted = tone === "onDark" ? "text-white/50" : "text-muted-foreground";
  const strong = tone === "onDark" ? "text-white/75" : "text-foreground/80";
  const strongHover = tone === "onDark" ? "group-hover:text-white hover:text-white" : "group-hover:text-foreground hover:text-foreground";

  return (
    <span
      translate="no"
      className={cn(
        "group inline-flex items-center whitespace-nowrap text-[11px] leading-none md:text-xs",
        muted,
        className
      )}
    >
      Made with{" "}
      <span
        aria-hidden="true"
        className={cn(
          "mx-[0.15em] inline-block transition-colors duration-200 ease-out motion-safe:group-hover:animate-[belead-pulse_350ms_ease-out_1]",
          strong,
          strongHover
        )}
      >
        ♡
      </span>{" "}
      by{" "}
      <a
        href="https://be-lead.org"
        target="_blank"
        rel="noopener noreferrer"
        className={cn(
          "ml-[0.25em] inline-flex font-medium rounded-sm",
          "decoration-current/60 decoration-[0.5px] underline-offset-2",
          "transition-all duration-200 ease-out hover:underline",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-transparent",
          strong,
          strongHover
        )}
      >
        BeLead
      </a>
    </span>
  );
}
